module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/projects",
      "title": "Projects"
    }
  }), _vm._v(" "), _c('projects-menu', {
    attrs: {
      "menu-items": _vm.types,
      "base-link": 'project-type',
      "currentItem": _vm.currentType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), (_vm.currentType.projects.length) ? _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.currentType.projects), function(project, index) {
    return _c('project', {
      key: index,
      attrs: {
        "project": project
      }
    })
  }), 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22fae80e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Type.vue
// module id = 907
// module chunks = 1